import React, { useState } from 'react';
import { BanknotesIcon } from '@heroicons/react/16/solid';
import classNames from 'classnames';
import dynamic from 'next/dynamic';

const SalaryDetailSlideover = dynamic(() => import('./SalaryDetailSlideover'), { ssr: false });

export default function SalaryDetail({ info, salary, jobTitle, iconColor, color, badgeClass, badgeStyle }) {
	const [open, setOpen] = useState(false);

	if (!info && !salary) {
		return null;
	}

	if (!info || !salary) {
		return (
			<div className={classNames('mt-2 flex items-center text-sm @sm:mr-2', badgeClass)} style={badgeStyle}>
				<BanknotesIcon
					style={{ color: iconColor }}
					aria-hidden="true"
					className="mr-1.5 h-5 w-5 flex-shrink-0"
				/>
				<span style={{ color }}>
					{info || salary}
				</span>
			</div>
		);
	}

	return (
		<>
			<div className={classNames('mt-2 flex items-center text-sm @sm:mr-2', badgeClass)} style={badgeStyle}>
				<BanknotesIcon
					style={{ color: iconColor }}
					aria-hidden="true"
					className="mr-1.5 h-5 w-5 flex-shrink-0"
				/>
				<button type="button" style={{ color }} className="underline text-left" onClick={() => setOpen(true)}>{salary}</button>
			</div>
			<SalaryDetailSlideover
				open={open}
				setOpen={setOpen}
				info={info}
				jobTitle={jobTitle}
			/>
		</>
	);
}
